<template>
    <div class="section-compare new-compare" :class="background" :style="getStyle()">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h1 class="h1 p-title p-center p-black relawayBold" :class="{'p-white':getType(), 'p-black':getType() }" >Compare electricity providers with TecknaEl.se</h1>
                    <p class="relawaySM max-max p-center" :class="{'p-white':getType(), 'p-black':getType() }">Find the best option for yourself in a few clicks </p>
                </div>
            </div>
            <div class="compare-form">
            <div class="range-form-item-inner">
                <div class="form-data-a">
                    <div class="box-centered">
                        <div class="load-data">
                            <input type="hidden" v-model="sum" max="400" >
                        </div>
                    </div>
                </div>
                <div class="ranges-slider__blck">
                    <template>
                        <range-slider
                                class="slider"
                                :min="1000"
                                :max="30000"
                                :step="1000"
                                v-model="electricity">
                        </range-slider>
                    </template>
                    <div class="slider__scales2">
                        <div class="scale_item"
                             v-for="(separator, num) in separators"
                             :style="'left:' + separator.percent + '%'"
                             :class="{'active' : null !== separator.label}">
                            <span class="item">
                                <span></span>
                            </span>
                            <button class="data__blck"
                                    style="left:-20px"
                                    @click="setRangeValue(num)"
                                    v-if="null !== separator.label"
                            >
                                <span>{{ separator.label }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row home-form">

                <div class="col-md-6 d-flex align-items-stretch">
                    <div class="info__blck">
                        <div class="form-group error electricity" :class="{'active': checkClass(electricity) }">
                            <label class="min-min p-white"
                                   @click="forLabelClick($event)"
                            >Electricity/year</label>
                            <input type="text"
                                   class="form-control"
                                   @focus="formControlFocus($event)"
                                   @blur="formControlBlur($event)"
                                   v-model.number="electricity"
                                   title="Electricity consumption/year">
                            <small>kWh</small>
                        </div>
                        <span class="error-text">Please enter your address</span>
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-stretch">
                    <div class="info__blck">
                        <div class="form-group error ">

                            <label class="min-min p-white"
                                   @click="forLabelClick($event)"
                            >Your postcode</label>

                            <input type="text" class="form-control"
                                   @focus="formControlFocus($event)"
                                   @blur="formControlBlur($event)"
                                   title="Electricity consumption/year" />
                            <div class="cntry_name"><span class="marker"><img src="/img/marker.svg" alt=""></span>Stockholm</div>
                        </div>
                        <span class="error-text">Please enter your address</span>
                    </div>
                </div>
            </div>

            <div class="description">
                <div class="row justify-content-center">
                    <div class="col-md-6 p-center">
                        <p class=" med mb-0" :class="{'p-white':getType(), 'p-black':getType() }">You save in average: <b>500 kr/year</b> by using <b>TecknaEl.se</b></p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-5">
                        <div class="compare-btn padding-mob">
                            <button class="btn btn-green btn-full">Compare prices</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>

</template>

<script>
    import RangeSlider from 'vue-range-slider'

    let labelsDesk = {
        0: "Apartment 2000 kWh/year",
        7: "House 9000 kWh/year",
        16: "Villa 18000 kWh/year",
    };

    let labelsMob = {
        0: "Apartment 2000 kWh/year",
        16: "Villa 18000 kWh/year",
    };

    let MobilePercent = [
        3.2, /** 2000 */
        6.6, /** 3000 */
        10.0, /** 4000 */
        13.5, /** 5000 */
        17.0, /** 6000 */
        20.5, /** 7000 */
        23.9, /** 8000 */
        27.3, /** 9000 */
        30.9, /** 10000 */
        34.3, /** 11000 */
        37.8, /** 12000 */
        41.2, /** 13000 */
        44.7, /** 14000 */
        48.2, /** 15000 */
        51.7, /** 16000 */
        55.0, /** 17000 */
        58.6, /** 18000 */
        61.9, /** 19000 */
        65.4, /** 20000 */
        68.8, /** 21000 */
        72.3, /** 22000 */
        75.7, /** 23000 */
        79.2, /** 24000 */
        82.6, /** 25000 */
        86.2, /** 26000 */
        89.5, /** 27000 */
        93.1, /** 28000 */
        96.4, /** 29000 */
    ];

    let DeskPercent =  [
        3.3, /** 2000 */
        6.7, /** 3000 */
        10.1, /** 4000 */
        13.6, /** 5000 */
        17.1, /** 6000 */
        20.6, /** 7000 */
        24.0, /** 8000 */
        27.4, /** 9000 */
        31.0, /** 10000 */
        34.4, /** 11000 */
        37.9, /** 12000 */
        41.3, /** 13000 */
        44.8, /** 14000 */
        48.3, /** 15000 */
        51.8, /** 16000 */
        55.1, /** 17000 */
        58.7, /** 18000 */
        62.0, /** 19000 */
        65.5, /** 20000 */
        68.9, /** 21000 */
        72.4, /** 22000 */
        75.8, /** 23000 */
        79.3, /** 24000 */
        82.7, /** 25000 */
        86.3, /** 26000 */
        89.6, /** 27000 */
        93.2, /** 28000 */
        96.5, /** 29000 */
    ];

    export default {
        name: "CompareSectNew",
        props: ['background'],
        data: function(){
            return {
                dropdownOpen: false,
                sliderValue: 50,
                sum: 1000,
                electricity: 2000,
                windowWidth: 0,
            }
        },
        components: {
            RangeSlider,

        },
        methods: {
            setRangeValue(num){
                this.electricity = (num + 2) * 1000
            },
            dropDownToggle(){
                this.dropdownOpen = !this.dropdownOpen
            },
            checkClass(enter) {
                if (enter === "") {
                    console.log(enter);
                    return false
                } else {
                    return true
                }
            },
            dropDownClose(){
                this.dropdownOpen = false
            },
            formControlFocus($event){
                $event.target.parentElement.classList.add('active');

            },
            formControlBlur($event){
                if($event.target.value === ""){
                    $event.target.parentElement.classList.remove('active');

                }

            },
            forLabelClick($event){
                console.log($event);
                if(!$event.target.parentElement.classList.contains("disabled")){
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();
                }

            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },
            getStyle(){
                if(this.background === 'background-img'){

                    return {backgroundImage: 'url("../../../../img/stockholm-market.png")'}
                }
            },
            getType(){
                if(this.background === 'background-img'){
                    return true;
                } else {
                    return false;
                }
            }

        },
        computed: {
            isMobile: function () {
                if(this.windowWidth > 991){
                    return false;
                } else {
                    return true;
                }

            },
            separators(){
                let output = [];
                let percents = [];
                let labels = [];

                if(this.windowWidth > 991){
                    percents = DeskPercent;
                    labels = labelsDesk;

                } else {

                    percents = MobilePercent;
                    labels =  labelsMob;
                }



                let key = 0;
                for(let percent of percents){

                    output.push({
                        percent,
                        label: labels[key] || null
                    });

                    key++
                }

                return output
            },

        },

        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
    
</script>
